const baseRegion = {
	wuhan:[
        {
            name: '江岸',
            label: ['后湖', '解放公园', '二七', '竹叶山花桥'],
            children: [{name:'后湖'}, {name:'解放公园'}, {name:'二七'}, {name:'竹叶山花桥'}],
        },
        {
            name: '江汉',
            label: ['杨汊湖', '王家墩', '江汉路', '新华路', '常青'],
            children: [{name:'杨汊湖'}, {name:'王家墩'}, {name:'江汉路'}, {name:'新华路'}, {name:'常青'}],
        },{
            name: '汉阳',
            label: ['四新', '王家湾', '钟家村', '七里庙'],
            children: [{name:'四新'}, {name:'王家湾'}, {name:'钟家村'}, {name:'七里庙'}],
        },
        {
            name: '武昌',
            label: ['徐东', '武昌老城区', '水果湖', '中南路', '中北路'],
            children: [{name:'徐东'}, {name:'武昌老城区'}, {name:'水果湖'}, {name:'中南路'}, {name:'中北路'}],
        },
        {
            name: '青山',
            label: ['建二', '红钢城', '天兴洲'],
            children: [{name:'建二'}, {name:'红钢城'}, {name:'天兴洲'}],
        },
        {
            name: '洪山',
            label: ['南湖', '白沙洲', '街道口', '卓刀泉', '东湖风景区', '杨春湖'],
            children: [{name:'南湖'}, {name:'白沙洲'}, {name:'街道口'}, {name:'卓刀泉'}, {name:'东湖风景区'}, {name:'杨春湖'}],
        },
        {
            name: '东西湖',
            label: ['金银湖', '吴家山', '常青花园', '走马岭'],
            children: [{name:'金银湖'}, {name:'吴家山'}, {name:'常青花园'}, {name:'走马岭'}],
        },
        {
            name: '汉南',
            label: ['纱帽'],
            children: [{name:'纱帽'}],
        },
        {
            name: '蔡甸',
            label: ['中法生态新城', '后宫湖', '奓山', '蔡甸城区'],
            children: [{name:'中法生态新城'}, {name:'后宫湖'}, {name:'奓山'}, {name:'蔡甸城区'}],
        },
        {
            name: '江夏',
            label: ['大花岭', '文化大道', '藏龙岛', '庙山', '纸坊', '五里界', '郑店'],
            children: [{name:'大花岭'}, {name:'文化大道'}, {name:'藏龙岛'}, {name:'庙山'}, {name:'纸坊'}, {name:'五里界'}, {name:'郑店'}],
        },
        {
            name: '黄陂', 
            label: ['盘龙城', '前川', '汉口北', '横店'],
            children: [{name:'盘龙城'}, {name:'前川'}, {name:'汉口北'}, {name:'横店'}],
        },
        {
            name: '新洲',
            label: ['阳逻', '新洲城区'],
            children: [{name:'阳逻'}, {name:'新洲城区'}],
        },
        {
            name: '武汉周边',
            label: ['鄂州', '咸宁', '郑州', '黄冈', '孝感', '神农架'],
            children: [{name:'鄂州'}, {name:'咸宁'}, {name:'郑州'}, {name:'黄冈'}, {name:'孝感'}, {name:'神农架'}],
        },
        {
            name: '东湖高新',
            label: ['关山', '光谷南', '鲁巷', '光谷东', '花山'],
            children: [{name:'关山'}, {name:'光谷南'}, {name:'鲁巷'}, {name:'光谷东'}, {name:'花山'}],
        },
        {
            name: '经济开发区',
            label: ['沌口', '军山'],
            children: [{name:'沌口'}, {name:'军山'}],
        },
        {
            name: '长江新城',
            label: ['武湖'],
            children: [{name:'武湖'}],
        }
    ]
}

export default baseRegion;